import React, { useState } from "react";
import { CloseIcon, PremiumIcon } from "@/svgs";
import "./PremiumFloating.css";

interface PremiumFloatingProps {
  navigate: () => void;
}

const PremiumFloating: React.FC<PremiumFloatingProps> = ({ navigate }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="premium-floating-footer">
      <button
        type="button"
        className="btn-close-premium"
        onClick={() => setIsVisible(false)}
        aria-label="Fechar anúncio"
      >
        <CloseIcon />
      </button>

      <div className="premium-footer-content">
        <div className="premium-footer-left">
          <div className="premium-footer-crown-wrapper">
            <PremiumIcon />
          </div>
          <div className="premium-footer-text-group">
            <span className="premium-footer-title">
              Acesso ilimitado aos melhores perfis
            </span>
            <span className="premium-footer-subtitle">
              Seja Premium e conecte-se com quem realmente combina com você.
            </span>
          </div>
        </div>

        <button type="button" className="btn-premium" onClick={navigate}>
          <PremiumIcon />
          <span className="btn-premium-text">Quero ser Premium</span>
        </button>
      </div>
    </div>
  );
};

export default PremiumFloating;
